import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {
    agregarCarton,
    eliminarCarton,
    actualizarCarton,
    actualizarCodUltimoCarton,
    actualizarErroresDeValidacionDeItem
} from "../../../actions/ventas/act_ven26";
import {v4 as uuidv4} from "uuid";

class DetalleCartones extends React.Component{
    constructor(props){
        super(props);
        this.state = {
        };
    }

    render(){
        const buttonStyle = {padding: '2px 3px', fontSize: '90%', lineHeight: '1.5', borderRadius: '2px'};
        const inputStyle = {height: '22px', padding: '2px 5px', fontSize: '100%', lineHeight: '1.5', borderRadius: '2px'};
        const tdStyle = {padding: '2px'}
        return (
                <div className='table-responsive' style={{marginBottom: '0px'}}>
                    <table className='table-condensed'>
                        <thead>
                            <tr>
                                <th className='col-sm-5 text-center' style={tdStyle}>Cartón</th>
                                <th className='col-sm-5 text-center' style={tdStyle}>Cant.</th>
                                <th className='col-sm-2' style={tdStyle}>
                                    <button type='button' className='btn btn-default' style={buttonStyle} onClick={()=>this.handleAddCarton(this.props.idItem)}>+</button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.detalleCartones.map(carton => (
                                <tr key={carton.idCarton}>
                                    <td style={tdStyle}>
                                        <input name='codCarton' type='text' value={carton.codCarton} maxLength={this.props.codCartonMaxLength} autoComplete='off' className='form-control' style={inputStyle}
                                               onChange = {(event) => {
                                                   let upperCaseValue = event.target.value.toUpperCase();
                                                   this.handleUpdateCarton(this.props.idItem, carton.idCarton, event.target.name, upperCaseValue);
                                               }}
                                               onBlur = {() => {
                                                   if(carton.codCarton.length > 0) {
                                                       this.props.actualizarCodUltimoCarton(carton.codCarton);
                                                   }
                                                   let errores = this.props.funcionValidacionDetalleCartones(this.props.detalleCartones, this.props.totalUnidades);
                                                   this.props.actualizarErroresDeValidacionDeItem(this.props.idItem, errores);
                                               }}
                                        />
                                    </td>
                                    <td style={tdStyle}>
                                        <input name='cantidad' type='number' min='1' value={carton.cantidad} autoComplete='off' className='form-control' style={inputStyle}
                                               onChange = {(event) => {
                                                   this.handleUpdateCarton(this.props.idItem, carton.idCarton, event.target.name, event.target.value);
                                               }}
                                               onBlur = {() => {
                                                   let errores = this.props.funcionValidacionDetalleCartones(this.props.detalleCartones, this.props.totalUnidades);
                                                   this.props.actualizarErroresDeValidacionDeItem(this.props.idItem, errores);
                                               }}
                                        />
                                    </td>
                                    <td style={tdStyle}>
                                        <button type='button' className='btn btn-danger' style={buttonStyle}
                                                onClick={() => {
                                                    this.handleDeleteCarton(this.props.idItem, carton.idCarton, () => {
                                                        let errores = this.props.funcionValidacionDetalleCartones(this.props.detalleCartones, this.props.totalUnidades);
                                                        this.props.actualizarErroresDeValidacionDeItem(this.props.idItem, errores);
                                                    });
                                                }}>
                                        X</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
        )
    }

    handleAddCarton = (idItem) => {
        const carton = {idCarton: uuidv4(), codCarton: '', cantidad: ''};
        this.props.agregarCarton(idItem, carton);
    }

    handleDeleteCarton = (idItem, idCarton, callback) => {
        this.props.eliminarCarton(idItem, idCarton).then(()=> {
            if (callback && typeof(callback) === 'function') {
                callback();
            }
        });
    }

    handleUpdateCarton = (idItem, idCarton, updatedProp, updatedValue) => {
        this.props.actualizarCarton(idItem, idCarton, updatedProp, updatedValue);
    }

}

const mapDispatchToProps = (dispatch => {
    return bindActionCreators({ agregarCarton, eliminarCarton, actualizarCarton, actualizarCodUltimoCarton, actualizarErroresDeValidacionDeItem }, dispatch);
});

export default connect(null, mapDispatchToProps)(DetalleCartones);